import { useState } from 'react'
import {
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  Input,
} from '@fluentui/react-components'
import { ChevronDown16Regular } from '@fluentui/react-icons'
import styles from './AccountFilter.module.css'
import { useProjektprognosSheetContext } from '../../context/ProjektprognosSheetContext'

export type { AccountInfo } from './types'

export const AccountFilter = () => {
  const {
    minDiff,
    setMinDiff,
    enableDiffFilter,
    setEnableDiffFilter,
    enableCommentFilter,
    setEnableCommentFilter,
    filterActive,
    setFilterActive,
  } = useProjektprognosSheetContext()

  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false)

  return (
    <div className={styles.filterButtonGroup}>
      <button
        className={`${styles.filterButton} ${styles.filterButtonMain} ${
          filterActive ? styles.filterButtonActive : ''
        }`}
        onClick={() => setFilterActive(!filterActive)}
      >
        <span>Filter fokus</span>
      </button>

      <Popover
        open={isAdvancedOpen}
        onOpenChange={(_, data) => setIsAdvancedOpen(data.open)}
        positioning="below-end"
      >
        <PopoverTrigger>
          <button
            className={`${styles.filterButtonChevron} ${
              filterActive ? styles.filterButtonActive : ''
            }`}
            aria-label="Fler filterinställningar"
          >
            <ChevronDown16Regular />
          </button>
        </PopoverTrigger>
        <PopoverSurface className={styles.advancedPopoverSurface}>
          <div className={styles.diffFilterContainer}>
            <Checkbox
              label="Visa konton med större differens än:"
              checked={enableDiffFilter}
              onChange={(_, data) => setEnableDiffFilter(data.checked === true)}
            />
            <Input
              type="number"
              value={minDiff.toString()}
              onChange={(_, data) => {
                const value = data.value.trim()
                if (value !== '') {
                  const num = parseFloat(value)
                  if (!isNaN(num)) {
                    setMinDiff(num)
                  }
                }
              }}
              contentAfter={<>tkr</>}
              disabled={!enableDiffFilter}
              placeholder="500"
              className={styles.diffAmountInput}
            />
          </div>

          <div className={styles.diffFilterContainer}>
            <Checkbox
              label="Visa konton med kommentar"
              checked={enableCommentFilter}
              onChange={(_, data) =>
                setEnableCommentFilter(data.checked === true)
              }
            />
          </div>
        </PopoverSurface>
      </Popover>
    </div>
  )
}

export default AccountFilter
